// src/components/PasswordFields.tsx
// Updated: 2026-08-20 15:00:00 CDT
// Purpose: Shared accessible new-password and confirmation controls.

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

interface PasswordFieldsProps {
  password: string;
  confirmation: string;
  disabled?: boolean;
  onPasswordChange: (value: string) => void;
  onConfirmationChange: (value: string) => void;
}

const PasswordFields = ({
  password,
  confirmation,
  disabled = false,
  onPasswordChange,
  onConfirmationChange,
}: PasswordFieldsProps) => (
  <>
    <div className="space-y-2">
      <Label htmlFor="new-password">New password</Label>
      <div className="relative">
        <Lock className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input
          id="new-password"
          type="password"
          autoComplete="new-password"
          minLength={8}
          placeholder="At least 8 characters"
          value={password}
          onChange={(event) => onPasswordChange(event.target.value)}
          className="pl-10"
          disabled={disabled}
          required
        />
      </div>
    </div>

    <div className="space-y-2">
      <Label htmlFor="confirm-password">Confirm new password</Label>
      <div className="relative">
        <Lock className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input
          id="confirm-password"
          type="password"
          autoComplete="new-password"
          minLength={8}
          placeholder="Enter the new password again"
          value={confirmation}
          onChange={(event) => onConfirmationChange(event.target.value)}
          className="pl-10"
          disabled={disabled}
          required
        />
      </div>
    </div>
  </>
);

export default PasswordFields;
